import { render, staticRenderFns } from "./QualityResult.vue?vue&type=template&id=8f768278"
import script from "./QualityResult.vue?vue&type=script&lang=js"
export * from "./QualityResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports